import { ApiUtil as api } from "@/utils/api.util.js";

export class DictionaryService {
  static URL = process.env.API_URL + process.env.API_VER;
  static RESOURCE = "/dictionaries/";

  static all(queryParams = {}) {
    return api.get(this.URL + this.RESOURCE, queryParams);
  }
}



// WEBPACK FOOTER //
// ./src/services/dictionary.service.js